import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import './FMAssetBindingModal.css';
import { Modal, Button, Transfer, Spin } from 'antd';

@inject('translationsStore')
@observer
export default class FMAssetBindingModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mockData: [],
      targetKeys: []
    };
  }

  componentDidMount() {
    this.getMock();
  }

  getMock = () => {
    const targetKeys = [];
    const mockData = [];
    for (let i = 0; i < 20; i++) {
      const data = {
        key: i.toString(),
        title: `content${i + 1}`,
        description: `description of content${i + 1}`,
        chosen: Math.random() * 2 > 1
      };
      if (data.chosen) {
        targetKeys.push(data.key);
      }
      mockData.push(data);
    }
    this.setState({ mockData, targetKeys });
  };

  handleChange = (...params) => {
    const { fleetManager } = this.props;
    this.props.onChange instanceof Function && this.props.onChange(fleetManager.id, ...params);
  };

  render() {
    const { translationsStore, visible, loading, bindingError, dataSource, targetKeys, fleetManager = {} } = this.props;
    const commonName =
      fleetManager.name === '' && fleetManager.surname === ''
        ? fleetManager.companyName
        : `${fleetManager.name} ${fleetManager.surname}${fleetManager.companyName !== '' ? `, ${fleetManager.companyName}` : ''}`;
    return (
      <Fragment>
        {visible && (
          <Modal
            title={translationsStore.translate('fleetManagers.assetsBinding.modal.title')}
            visible={visible}
            footer={null}
            onOk={this.props.onOk}
            onCancel={this.props.onCancel}
            width={760}
            className="FMAssetBinding"
          >
            <div className="AssetBindingFleetManager" style={{ marginBottom: 20 }}>
              <div className="FieldFleetManager">{translationsStore.translate('fleetManagers.assetsBinding.modal.labelFleetManager')}</div>
              <div className="ValueFleetManager">{commonName}</div>
            </div>
            <div className="AssetBindingColumns">
              <div>{translationsStore.translate('fleetManagers.assetsBinding.modal.labelAvailableAssets')}</div>
              <div></div>
              <div>{translationsStore.translate('fleetManagers.assetsBinding.modal.labelAssignedAssets')}</div>
            </div>
            <Spin spinning={!!loading}>
              <Transfer
                className="TransferBinding"
                dataSource={dataSource}
                targetKeys={targetKeys}
                showSearch={true}
                listStyle={{}}
                onChange={this.handleChange}
                render={item => `${item.title}`}
                locale={{ itemUnit: translationsStore.translate('fleetManagers.assetsBinding.modal.labelElement'), itemsUnit: translationsStore.translate('fleetManagers.assetsBinding.modal.labelElements'), notFoundContent: translationsStore.translate('fleetManagers.assetsBinding.modal.labelNoElement'), searchPlaceholder: translationsStore.translate('fleetManagers.assetsBinding.modal.labelAssetFilter') }}
              />
            </Spin>
            {bindingError && <div style={{ margin: '20px 0', display: 'flex', alignItems: 'center' }}>{bindingError}</div>}
          </Modal>
        )}
      </Fragment>
    );
  }
}
